import React, { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { Provider, useSelector, useDispatch } from "react-redux";

import LoginWidget from "./LoginWidget";
import { store } from "../../redux/store";
import DefaultLoginPage from "./DefaultLoginPage";
import { APP_ENVIRONMENT } from "../../Constants/Constants";
import { getStorageItem, removeStorageItem, setStorageItem } from "../../utils/storageFunction";
import { getZinoDomainAppData } from "../../utils/apiCallFunction";
import { setIsMobileUserAgent } from "../../redux/userview/userviewaction";
import LoginWidgetSso from "./LoginWidgetSso";
import InstallPromptBanner from "../../Hook/InstallPromptBanner";

const LoginPage = () => {
  const containerRef = useRef(null);
  const domainData = JSON.parse(localStorage.getItem("Zino_domain_app_data"));

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authenticate, logincall, user, isMobileUserAgent } = useSelector((state) => state.userviewstore);
  let environmentValue = APP_ENVIRONMENT || "local";

  useEffect(() => {
    if (authenticate && !logincall && getStorageItem("Zino_app_user")) {
      let environmentValue = APP_ENVIRONMENT || "local";
      let userGoto = user?.goto_page;
      if (userGoto && environmentValue !== "local") {
        userGoto = userGoto.split("/");
        let app_id = getStorageItem("Zino_app_id");
        if (app_id) {
          userGoto = `/${app_id}/${userGoto[userGoto.length - 1]}`;
        } else {
          userGoto = `/${userGoto[userGoto.length - 1]}`;
        }
        navigate(userGoto);
      }

      navigate("/applist");
    }

    document.title = `${getZinoDomainAppData()?.title || "Zino"} || Login`;

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticate, logincall]);

  useEffect(() => {
    removeStorageItem("", [
      "Zino_public_app_id",
      "Zino_public_domain_web",
      "Zino_public_app_name",
      "Zino_app_id",
      "Zino_domain_web",
      "Zino_app_name",
      "Zino_app_theme_id",
      "Zino_app_user_go_to",
      "Zino_app_module_header",
      "selectedApp"
    ]);
  }, []);

  const customHtml = domainData?.custom_login_html;

  useEffect(() => {
    if (containerRef.current) {
      const loginDiv = containerRef.current.querySelector("#login-widget");

      const loginSsoDiv = containerRef.current.querySelector("#login-widget-sso");

      if (loginDiv) {
        const root = createRoot(loginDiv);

        root.render(
          <Provider store={store}>
            <BrowserRouter>
              <LoginWidget domainData={domainData} />
            </BrowserRouter>
          </Provider>
        );
      }
      if (loginSsoDiv) {
        const root = createRoot(loginSsoDiv);

        root.render(
          <Provider store={store}>
            <BrowserRouter>
              <LoginWidgetSso domainData={domainData} />
            </BrowserRouter>
          </Provider>
        );
      }
      if (!loginDiv && !loginSsoDiv) {
        console.warn("No #login-widget found in custom HTML");
      }
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customHtml]);

  let content = null;

  if (domainData?.enable_custom_login_html && customHtml) {
    content = (
      <>
        {" "}
        {environmentValue === "local" && (
          <div className="login_page_appbar_dev_hide">
            <label className="switch-mobile-desktop">
              <input
                className="switch-mobile-desktop-input"
                type="checkbox"
                checked={isMobileUserAgent}
                onChange={(e) => {
                  dispatch(setIsMobileUserAgent(e.target.checked));
                  setStorageItem("Zino_Is_Mobile_User_Agent", e.target.checked);
                }}
              />
              <span className="switch-mobile-desktop-slider"></span>
              <span className="material-symbols-outlined switch-desktop-slider">laptop_windows</span>
              <span className="material-symbols-outlined switch-mobile-slider">phone_android</span>
            </label>
          </div>
        )}
        <InstallPromptBanner />
        <div ref={containerRef} dangerouslySetInnerHTML={{ __html: customHtml }} />
      </>
    );
  } else {
    content = <DefaultLoginPage />;
  }

  return content;
};

export default LoginPage;
